(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-trust-accordion"] && !Shopify.designMode) return;
  try {
    
  const initializeKodaFaq = (root = document) => {
    root.querySelectorAll('[data-koda-faq]').forEach((accordion) => {
      if (accordion.dataset.initialized === 'true') return;
      accordion.dataset.initialized = 'true';

      accordion.querySelectorAll('.koda-faq-item__button').forEach((button) => {
        button.addEventListener('click', () => {
          const panel = document.getElementById(button.getAttribute('aria-controls'));
          if (!panel) return;
          const isExpanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!isExpanded));
          panel.hidden = isExpanded;
        });
      });
    });
  };

  initializeKodaFaq();
  document.addEventListener('shopify:section:load', (event) => initializeKodaFaq(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!window.__kodaCollectionBound) {
    window.__kodaCollectionBound = true;

    const storagePrefix = 'koda-collection-filter:';
    const applyAccordionState = (scope = document) => {
      scope.querySelectorAll('.koda-filter-group[data-koda-filter-key]').forEach((details) => {
        const key = details.getAttribute('data-koda-filter-key');
        const stored = sessionStorage.getItem(storagePrefix + key);
        if (stored !== null) details.open = stored === 'true';
        const summary = details.querySelector('.koda-filter-group__summary');
        summary?.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      });
    };

    const restoreDrawerForm = (dialog) => {
      if (dialog?.dataset.kodaApplied === 'true') return;
      dialog?.querySelectorAll('[data-koda-original-checked], [data-koda-original-value]').forEach((input) => {
        if (!(input instanceof HTMLInputElement) && !(input instanceof HTMLSelectElement)) return;
        if (input instanceof HTMLInputElement && (input.type === 'checkbox' || input.type === 'radio')) {
          input.checked = input.dataset.kodaOriginalChecked === 'true';
        } else {
          input.value = input.dataset.kodaOriginalValue || '';
        }
      });
    };

    const snapshotDrawerForm = (dialog) => {
      dialog.dataset.kodaApplied = 'false';
      dialog.querySelectorAll('input, select').forEach((input) => {
        if (!(input instanceof HTMLInputElement) && !(input instanceof HTMLSelectElement)) return;
        if (input instanceof HTMLInputElement && (input.type === 'checkbox' || input.type === 'radio')) {
          input.dataset.kodaOriginalChecked = input.checked ? 'true' : 'false';
        } else {
          input.dataset.kodaOriginalValue = input.value;
        }
      });
    };

    const url = new URL(window.location.href);
    if (url.hash) {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          const card = document.getElementById(url.hash.slice(1));
          if (card) {
            card.scrollIntoView({ behavior: 'instant' });
          }
        },
        { once: true }
      );
    }

    document.addEventListener('toggle', (event) => {
      const details = event.target.closest?.('.koda-filter-group[data-koda-filter-key]');
      if (!details) return;
      const key = details.getAttribute('data-koda-filter-key');
      sessionStorage.setItem(storagePrefix + key, details.open ? 'true' : 'false');
      details.querySelector('.koda-filter-group__summary')?.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    }, true);

    document.addEventListener('click', (event) => {
      const showMoreButton = event.target.closest('[data-koda-show-more]');
      if (showMoreButton) {
        event.preventDefault();
        const group = showMoreButton.closest('.koda-filter-group');
        const expanded = group?.classList.toggle('koda-filter-group--expanded');
        group?.querySelectorAll('.koda-filter-option--collapsed').forEach((option) => {
          if (expanded) {
            option.hidden = false;
            option.setAttribute('aria-hidden', 'false');
          } else if (!group.classList.contains('koda-filter-group--searching')) {
            option.hidden = true;
            option.setAttribute('aria-hidden', 'true');
          }
        });
      }

      const drawerTrigger = event.target.closest('[data-koda-filter-drawer-trigger]');
      if (drawerTrigger) {
        const drawerId = drawerTrigger.getAttribute('data-koda-filter-drawer-trigger');
        const dialog = document.querySelector(`#${drawerId} dialog`);
        if (dialog) snapshotDrawerForm(dialog);
      }
    });

    document.addEventListener('input', (event) => {
      const searchInput = event.target.closest('[data-koda-filter-search]');
      if (!searchInput) return;

      const query = searchInput.value.trim().toLowerCase();
      const group = searchInput.closest('.koda-filter-group');
      group?.classList.toggle('koda-filter-group--searching', query !== '');
      group?.querySelectorAll('[data-koda-filter-option]').forEach((option) => {
        const label = option.querySelector('.koda-filter-option__label')?.textContent?.toLowerCase() || '';
        const matches = query === '' || label.includes(query);
        option.hidden = !matches;
        option.setAttribute('aria-hidden', matches ? 'false' : 'true');
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      const priceInput = event.target.closest('.koda-price-filter input');
      if (!priceInput || priceInput.closest('.koda-filter-drawer__dialog')) return;
      event.preventDefault();
      priceInput.closest('price-facet-component')?.updatePriceFilterAndResults?.();
    });

    document.addEventListener('click', (event) => {
      const applyButton = event.target.closest('[data-koda-filter-apply]');
      if (!applyButton) return;

      const drawer = applyButton.closest('dialog');
      const facetsForm = applyButton.closest('facets-form-component');
      const drawerComponent = applyButton.closest('dialog-component');
      if (drawer) drawer.dataset.kodaApplied = 'true';
      facetsForm?.updateFilters?.();
      drawerComponent?.closeDialog?.();
    });

    document.addEventListener('close', (event) => {
      const dialog = event.target;
      if (dialog?.matches?.('.koda-filter-drawer__dialog')) {
        restoreDrawerForm(dialog);
      }
    }, true);

    document.addEventListener('filter:update', () => {
      const collectionMain = document.querySelector('.koda-collection-main');
      collectionMain?.classList.add('koda-collection-main--updating');
      const count = collectionMain?.querySelector('[data-koda-objects-count]');
      if (count) count.textContent = 'Updating...';
      window.setTimeout(() => applyAccordionState(document), 300);
      window.setTimeout(() => applyAccordionState(document), 700);
    });

    document.addEventListener('DOMContentLoaded', () => applyAccordionState(document), { once: true });

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element && node.querySelector?.('.koda-filter-group')) {
            applyAccordionState(node);
          }
        });
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  class KodaFaqList extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('details').forEach((details) => {
        const summary = details.querySelector('summary');
        if (!summary) return;
        const sync = () => summary.setAttribute('aria-expanded', String(details.open));
        details.addEventListener('toggle', sync);
        sync();
      });
    }
  }

  if (!customElements.get('koda-faq-list')) customElements.define('koda-faq-list', KodaFaqList);

  } catch(e) { console.error(e); }
})();
})();
